<template>
  <v-container fluid>
    <form @submit.prevent="submitForm">
      <div class="mb-3">
        <h5>ক্ষুদ্র নৃ-গোষ্ঠী কি না?</h5>
        <v-radio-group v-model="form.ethnic_group" inline>
          <v-radio label="হ্যাঁ" value="yes"></v-radio>
          <v-radio label="না" value="no"></v-radio>
        </v-radio-group>
      </div>

      <div class="mb-3">
        <h5>প্রতিবন্ধী কি না?</h5>
        <v-radio-group v-model="form.disabled" inline>
          <v-radio label="হ্যাঁ" value="yes"></v-radio>
          <v-radio label="না" value="no"></v-radio>
        </v-radio-group>
      </div>

      <v-btn color="primary" size="large" class="me-3 rounded-lg" type="submit">
        <v-icon start>mdi-content-save-outline</v-icon>সংরক্ষণ করুন
      </v-btn>
      <v-btn color="grey-darken-1" variant="outlined" size="large" class="rounded-lg" @click="resetForm">
        <v-icon start>mdi-refresh</v-icon>রিসেট
      </v-btn>
    </form>
  </v-container>
</template>

<script>
export default {
  name: "DisabledComponent",
  data() {
    return {
      form: {
        ethnic_group: 'no',
        disabled: 'no',
      }

    }
  },
  mounted() {},
  methods: {
    submitForm() {
      console.log(this.form);
    },

    resetForm() {
      this.form = {
        ethnic_group: 'no',
        disabled: 'no',
      };
    },
  },
};
</script>
